import React, { Component } from "react";
import { Glyphicon } from "react-bootstrap";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";

import "react-table/react-table.css";
import styles from "./AdminTable.scss";

import { sortWhiteList } from "../../../utils/parseSortData";

const CheckboxTable = checkboxHOC(ReactTable);

class AdminTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selection: [],
      selectAll: false
    };

    this.getSortedComponent = this.getSortedComponent.bind(this);
    this.onSortedChange = this.onSortedChange.bind(this);
  }

  getSortedComponent(id, sortable) {
    let sortInfo =
      this.props.sortData && this.props.sortData.filter(item => item.id === id);

    if (sortInfo && sortInfo.length) {
      if (sortInfo[0].desc === true)
        return <Glyphicon glyph={"triangle-bottom"} />;
      if (sortInfo[0].desc === false)
        return <Glyphicon glyph={"triangle-top"} />;
    }

    if (sortable) return <Glyphicon glyph={"sort"} />;

    return null;
  }

  getColumns() {
    const genericHeaderArrows = sortable => {
      return {
        Header: props => {
          const Sorted = this.getSortedComponent(props.column.id, sortable);
          return (
            <span>
              {props.column.headerText} {Sorted}
            </span>
          );
        },
        headerClassName: styles.header
      };
    };

    const columns = this.props.tableColumns.map(item => {
      const sortable = item.sortable;

      return {
        ...genericHeaderArrows(sortable),
        headerClassName: styles.header,
        ...item
      };
    });
    return columns;
  }

  toggleSelection = key => {
    let selection = [...this.state.selection];
    const keyIndex = selection.indexOf(key);
    if (keyIndex >= 0) {
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ];
    } else {
      selection.push(key);
    }
    this.setState({ selection });

    this.props.onUpdate(selection);
  };

  toggleAll = () => {
    const selectAll = this.state.selectAll ? false : true;
    const selection = [];
    if (selectAll) {
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      const currentRecords = wrappedInstance.getResolvedState().sortedData;

      // Select all
      currentRecords.forEach(item => {
        selection.push(item._original.id);
      });

      // Select only records from current page
      // const inst = wrappedInstance.state;
      // let i = inst.page * inst.defaultPageSize;
      // let j = (inst.page + 1) * inst.defaultPageSize;
      // for (i; i < j; i++) {
      //   if (currentRecords[i] && currentRecords[i]._original) {
      //     selection.push(currentRecords[i]._original.id);
      //   }
      // }
    }

    this.setState({ selectAll, selection });
    this.props.onUpdate(selection);
  };

  isSelected = key => {
    return this.state.selection.includes(key);
  };

  onSortedChange(sortData) {
    const sortName = _.get(sortData, "[0].id");
    if (sortWhiteList[sortName] && this.props.onSortChange) {
      this.props.onSortChange(sortData);
    }
  }

  getRowBackgroundColor(row) {
    let color = "#ffffff";

    if (row && row.original) {
      if (this.isSelected(row.original.id)) {
        color = "#e6f3fa";
      } else {
        switch (row.original.sort_status) {
          case "Matched":
            color = "#e3f0ea";
            break;
          case "Declined":
          case "Pitch Rejected":
            color = "#fdf5f6";
            break;
        }
      }
    }

    return color;
  }

  render() {
    const { toggleSelection, toggleAll, isSelected } = this;
    const { selectAll } = this.state;
    const {
      selectable,
      tableData,
      loading,
      noRowsText,
      expandible,
      subcomponent,
      page,
      sortData
    } = this.props;

    const tableProps = {
      data: this.props.tableData,
      columns: this.getColumns(),
      page: page,
      manual: true,
      ref: r => (this.checkboxTable = r),
      resolveData: data => data.map(row => row),
      style: this.props.style,
      defaultPageSize: tableData.length,
      showPagination: true,
      showPaginationBottom: true,
      pages: this.props.numberOfPages,
      onPageChange: this.props.onPageChange,
      showPageSizeOptions: false,
      showPageJump: false,
      keyField: "id",
      className: styles.adminTable,
      sorted: sortData || [],
      onSortedChange: this.onSortedChange,
      loading: loading,
      noDataText: noRowsText,
      getTdProps: () => {
        return {
          style: {
            display: "flex",
            alignItems: "center",
            minHeight: "60px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRight: "1px solid rgba(0,0,0,0.05)",
            wordBreak: "break-all",
            whiteSpace: "normal"
          }
        };
      },
      getTrProps: () => {
        return {
          style: {
            // maxHeight: "60px",
            backgroundColor: "#ffffff"
          }
        };
      }
    };

    const checkboxProps = {
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
      selectType: "checkbox",
      getTrProps: (s, r) => {
        return {
          onClick: () => {
            this.toggleSelection(r.original.id);
          },
          style: {
            alignItems: "center",
            backgroundColor: this.getRowBackgroundColor(r),
            minHeight: "60px"
          }
        };
      }
    };

    if (selectable) {
      return <CheckboxTable {...tableProps} {...checkboxProps} />;
    }

    if (expandible) {
      return <ReactTable {...tableProps} SubComponent={subcomponent} />;
    }

    return <ReactTable {...tableProps} />;
  }
}

export default AdminTable;



// WEBPACK FOOTER //
// ./src/components/common/table/AdminTable.js